import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AdresAfbeeldingModule } from '@app/shared/adres-afbeelding/adres-afbeelding.module';
import { ProductModule } from '@app/shared/product/product.module';
import { RobotComponent } from '@app/shared/ui/robot/robot.component';
import { RobotModule } from '@app/shared/ui/robot/robot.module';
import { SchadenummerComponent } from '@app/shared/ui/schadenummer/schadenummer.component';
import { SchadenummerModule } from '@app/shared/ui/schadenummer/schadenummer.module';
import { CatModule } from './cat/cat.module';

@NgModule({
    imports: [
        CommonModule,
        AdresAfbeeldingModule,
        ProductModule,
        RobotModule,
        SchadenummerModule,
    ],
    exports: [
        RobotComponent,
        AdresAfbeeldingModule,
        SchadenummerComponent,
        CatModule,
    ],
})

/** @deprecated use the individual component modules from src/app/shared/ui folder */
export class UiModule {
}
